var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.578937 15.917L8.87553 1.99913C9.9294 2.6071 15.2436 5.4889 16.1019 6.03699L7.80527 19.9556C6.89793 21.1302 -0.570592 17.6995 0.578937 15.9162V15.917Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4176 15.9167L16.121 1.9997C14.9612 0.108278 12.4632 -0.579078 10.4114 0.538043C8.35956 1.65517 7.73482 4.06158 8.8947 6.03747L17.1913 19.9562C18.3512 21.8468 20.8493 22.534 22.9011 21.417C24.8631 20.2998 25.5775 17.808 24.4176 15.9183V15.9167Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17056 21.9549C6.47066 21.9549 8.33526 20.1732 8.33526 17.9753C8.33526 15.7775 6.47066 13.9958 4.17056 13.9958C1.87046 13.9958 0.00585938 15.7775 0.00585938 17.9753C0.00585938 20.1732 1.87046 21.9549 4.17056 21.9549Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google-ads.cc0b01cfb7363b18dc614e33a6f98963.svg";
export { ForwardRef as ReactComponent };